import React from 'react';

export const NotRunning = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--no-product';
  color = color || '#0076CC';

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...{className}}>
      <path d="M20.9422 12.0185C21.1536 10.1628 20.7824 8.28734 19.8801 6.65207C18.9778 5.01679 17.5891 3.70273 15.9065 2.89205C14.224 2.08136 12.3309 1.81422 10.4897 2.12764C8.64847 2.44107 6.95039 3.31954 5.63082 4.64127C4.31126 5.96301 3.43557 7.66253 3.12517 9.50424C2.81477 11.346 3.08503 13.2386 3.89847 14.9198C4.71192 16.6011 6.02826 17.9876 7.66502 18.8872C9.30177 19.7868 11.1779 20.1549 13.0332 19.9405M12.0002 6.00066V11.0007L14.0002 13.0007M17.0004 16.0008V21.0008M21.0004 16.0008V21.0008" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default NotRunning;

